/**
 * 홈 섹션 공용 스타일 (2026-10-12 #47-2) — 홈 (src/app/page.tsx) 과 다른 화면이 같은 값을 쓰도록 한 곳에서 정의한다.
 * 새 UI 블록은 여기 값을 재사용하고 홈 섹션과 computed style 비교로 증명한다 (CLAUDE.md).
 * 사용처: 홈 Problem · HowItWorks 소제목 · Problem 제목 · Problem 카드 · Hero CTA · QuickActionBar · 노트 글 하단 CTA (NoteCta.tsx).
 */
import type { CSSProperties } from "react";

/** 홈 'The Problem' 섹션 배경 (연한 빨강). */
export const HOME_SECTION_BG = "#FBEEEC";

/** 홈 Problem 카드 모서리. */
export const HOME_CARD_RADIUS = 8;

/** 홈 섹션 소제목 ('The Problem' · 'Proven Method') — 빨간 이탤릭 영문. */
export const HOME_EYEBROW_CLASS = "text-[color:var(--color-red-text)]";
export const HOME_EYEBROW_STYLE: CSSProperties = {
  fontFamily: "var(--font-display)",
  fontStyle: "italic",
  fontSize: 16,
  fontWeight: 500,
};

/** 홈 'The Problem' 섹션 제목 (h2). 강조 부분은 HOME_TITLE_EM_CLASS. */
export const HOME_TITLE_CLASS = "text-[color:var(--color-ink)] break-keep";
export const HOME_TITLE_STYLE: CSSProperties = {
  fontSize: "clamp(22px, 4vw, 40px)",
  fontWeight: 800,
  lineHeight: 1.25,
  letterSpacing: "-0.015em",
};
export const HOME_TITLE_EM_CLASS = "text-[color:var(--color-red)]";

/** 홈 히어로 "MAP TEST 모의고사 무료 체험하기" 버튼 모양 (크기·모서리·글자 · 색은 별도). */
export const HOME_CTA_SHAPE_CLASS =
  "inline-flex items-center justify-center text-center h-[48px] px-6 rounded-[12px] text-[16px] font-bold leading-[1.25] lg:h-auto lg:px-[clamp(20px,3.4vw,36px)] lg:py-[clamp(14px,2.2vw,20px)] lg:rounded-[8px] lg:text-[length:clamp(16px,1.6vw,19px)] lg:font-extrabold";

/** 홈 상단 두 버튼 색 (2026-10-16 대표 지시 · 요금제 1회권 버튼과 같은 빨강 #DC2626 + 광택 .plan-gloss · 흰 글자 · 움직이는 빛 없음). */
export const HOME_RED_GLOSS_BTN_CLASS =
  "bg-[#DC2626] plan-gloss text-white hover:bg-[#B91C1C] active:bg-[#B91C1C]";

/** 홈 상단 Start 버튼 색 (마젠타 · 흰 글자 5.44:1 · 반짝임 .qa-shimmer 띠 지날 때도 4.5 이상). */
export const HOME_MAGENTA_BTN_CLASS =
  "bg-[#D1005B] text-white shadow-[0_2px_6px_rgba(209,0,91,0.25)] hover:bg-[#B0004C] active:bg-[#B0004C]";
